import React, { useContext, useState } from "react";
import { useTextDomainContext, useUser } from "@/app/providers";
import {
  Box,
  Button,
  Drawer,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { bool, func, object } from "prop-types";
import { useAddCompanyToTenant } from "@/hooks";
import { CustomerDropdown } from "@/components";

type LinkCompanyProps = {
  open?: boolean;
  handleClose: () => void;
  row?: {
    tenantId?: string;
  };
};

type CustomerOption = {
  value?: string;
};

export const LinkCompany = (props: LinkCompanyProps) => {
  //#region Data

  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { user } = useUser();
  const tenantId = props?.row?.tenantId || "";

  //#endregion Data

  //#region useState

  const [companyId, setCompanyId] = useState(user?.currentTeamId);

  //#endregion useState

  //#region useEffect

  //#endregion useEffect

  //#region Handlers

  const { addCompanyToTenant } = useAddCompanyToTenant();

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const variables = {
      tenantId,
      companyId,
    };

    addCompanyToTenant({
      variables,
    }).then();
  };

  const handleChangeCustomer = (event: CustomerOption) => {
    setCompanyId(event?.value);
  };

  const handleClose = () => {
    props.handleClose();
  };

  //endregion Handlers

  return (
    <Drawer
      anchor={"right"}
      open={props.open}
      onClose={handleClose}
      sx={{
        zIndex: (theme) => theme.zIndex.appBar + 1,
      }}
      slotProps={{
        paper: {
          sx: {
            padding: 4,
            minWidth: 500,
            maxWidth: 720,
          },
        },
      }}
    >
      <Box
        sx={{
          width: "auto",
        }}
      >
        <form onSubmit={submitHandler}>
          <Stack
            spacing={4}
            sx={{
              height: "100%",
            }}
          >
            <Typography sx={{ fontSize: 22, fontWeight: 700 }}>
              {gettext("Link company")}
            </Typography>

            <Box
              sx={{
                height: "100%",
              }}
            >
              <Grid container spacing={4} sx={{ width: "100%" }}>
                <Grid size={{ xs: 12 }}>
                  <CustomerDropdown
                    onChange={handleChangeCustomer}
                    componentLabel={gettext("Companies")}
                    currentTeamId={user?.currentTeamId}
                    currentTenantId={user?.currentTenantId}
                  />
                </Grid>
              </Grid>
            </Box>

            <Paper elevation={0}>
              <Grid container spacing={4} sx={{ width: "100%" }}>
                <Grid size={{ xs: 6 }} sx={{ textAlign: "center" }}>
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => handleClose()}
                  >
                    {gettext("Cancel")}
                  </Button>
                </Grid>

                <Grid size={{ xs: 6 }} sx={{ textAlign: "center" }}>
                  <Button
                    variant="contained"
                    loading={false}
                    fullWidth
                    type="submit"
                  >
                    {gettext("Link")}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Stack>
        </form>
      </Box>
    </Drawer>
  );
};

LinkCompany.propTypes = {
  open: bool,
  handleClose: func,
  row: object,
};
